module.exports = __webpack_public_path__ + "static/mention_04-b2c60c3e7c641ef182c4c3f7f9d6d8a0.png";